export const compositeQuestionTypes = {
  weatherUrl: 'weatherUrl',
  dateRange: 'dateRange',
  default: 'default',
}
